import { ReactElement } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { breakpoints } from '../../../theme/breakpoints'
import { useNavigate } from 'react-router-dom'
import { CustomizeSearchContext } from '../../../store/customiseSearch/CustomizeSearchStore'
import { Collapse } from 'react-bootstrap'
import { AdvancedVehicleSearch } from './AdvancedVehicleSearch'
import { SelectedVehicle } from './SelectedVehicle'
import {
  useVehicleWidgetStore,
  VehicleWidgetDisplayState,
  VehicleWidgetErrorState,
  VehicleWidgetStoreContext,
} from './store/VehicleWidgetStore'
import { SimpleModal } from '../../../ui-components'
import { StoreInstances } from '../../../store/StoreInstancesContainer'
import { CustomizeSearchModal } from '../../customizeSearch/components/CustomizeSearchModal'
import Sticky from 'react-stickynode'
import { isMobile } from 'react-device-detect'
import { useUiStateStore } from '../../../store/uiState/UiStateStore'
import { SearchOptions } from '../../customizeSearch/interfaces'
import { defaultTheme } from '../../../theme'

interface VehicleWidgetProps {
  isSticky?: boolean
}

export const VehicleWidget = observer(
  (props: VehicleWidgetProps): ReactElement => {
    const { isSticky = false } = props
    const vehicleWidgetStore = useVehicleWidgetStore()
    const { showCustomizeSearchModal } = useUiStateStore()
    const navigate = useNavigate()

    const viewMode =
      vehicleWidgetStore.displayState === VehicleWidgetDisplayState.view

    return (
      <Sticky top={160} innerZ={2} enabled={isMobile && isSticky}>
        <Collapse in={vehicleWidgetStore.isDrawerOpened}>
          <CollapseVehicleWidget id="collapse-vehicle-widget">
            <VehicleWidgetStoreContext.Provider value={vehicleWidgetStore}>
              <CustomizeSearchContext.Provider
                value={StoreInstances.customizeSearchStore}
              >
                <Container>
                  {viewMode ? (
                    <SelectedVehicle
                      onEditVehicle={() => {
                        vehicleWidgetStore.setDisplayState(
                          VehicleWidgetDisplayState.edit
                        )
                      }}
                    />
                  ) : (
                    vehicleWidgetStore.isDrawerOpened && (
                      <AdvancedVehicleSearch />
                    )
                  )}
                  <SimpleModal
                    show={
                      vehicleWidgetStore.errorState ===
                      VehicleWidgetErrorState.vehicleNotFound
                    }
                    title="vehicleNotFound"
                    primaryActionText="vehicleSearch"
                    onPrimaryAction={() => {
                      vehicleWidgetStore.clearErrorState()
                      navigate('/home')
                      StoreInstances.customizeSearchStore.setSelectedTab(
                        SearchOptions.vehicle_ymme
                      )
                    }}
                    onSecondaryAction={vehicleWidgetStore.clearErrorState}
                  >
                    aVehicleWasNotFound
                  </SimpleModal>
                  <SimpleModal
                    show={
                      vehicleWidgetStore.errorState ===
                      VehicleWidgetErrorState.vehicleIncomplete
                    }
                    title="vehicleIncomplete"
                    primaryActionText="continue"
                    onPrimaryAction={vehicleWidgetStore.clearErrorState}
                    onSecondaryAction={vehicleWidgetStore.clearErrorState}
                  >
                    vehicleInformationWasIncomplete
                  </SimpleModal>
                  <SimpleModal
                    show={
                      vehicleWidgetStore.errorState ===
                      VehicleWidgetErrorState.vinDigitCheckFailed
                    }
                    title="invalidVin"
                    primaryActionText="continue"
                    onPrimaryAction={vehicleWidgetStore.clearErrorState}
                    onSecondaryAction={vehicleWidgetStore.clearErrorState}
                  >
                    thisVinIsInvalidTryAgain
                  </SimpleModal>
                </Container>
                {showCustomizeSearchModal && <CustomizeSearchModal />}
              </CustomizeSearchContext.Provider>
            </VehicleWidgetStoreContext.Provider>
          </CollapseVehicleWidget>
        </Collapse>
      </Sticky>
    )
  }
)

const Container = styled.div`
  background-color: #fafafa;
  border-top: 1px solid ${defaultTheme.colors.disabledBackground};
  border-bottom: 1px solid ${defaultTheme.colors.disabledBackground};
  padding: 24px 24px 24px 24px;

  @media screen and (width < ${breakpoints.tabletLarge}px) {
    padding: 12px 18px 16px 16px;
  }

  @media print {
    display: none;
  }
`

const CollapseVehicleWidget = styled.div`
  border: 1px solid ${defaultTheme.colors.border};
`
